// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import {
//   FaStore,
//   FaUserShield,
//   FaUser,
//   FaEnvelope,
//   FaTags,
//   FaClipboardList,
//   FaDollarSign,
//   FaChartLine,
//   FaTrash,
// } from 'react-icons/fa';
// import { Line, Pie } from 'react-chartjs-2';

// const AdminDashboard = () => {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       try {
//         const response = await axios.get('/api/admin/dashboard', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setDashboardData(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching dashboard data:', error);
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, [token]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   const pieData = {
//     labels: dashboardData.restaurantsByMembership.map((item) => item._id),
//     datasets: [
//       {
//         data: dashboardData.restaurantsByMembership.map((item) => item.count),
//         backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
//         hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
//       },
//     ],
//   };

//   const lineData = {
//     labels: dashboardData.subscriptionGrowth.map(
//       (item) => `${item._id.month}/${item._id.year}`
//     ),
//     datasets: [
//       {
//         label: 'Customer Subscriptions Growth',
//         data: dashboardData.subscriptionGrowth.map((item) => item.total),
//         fill: false,
//         borderColor: '#42A5F5',
//       },
//     ],
//   };

//   return (
//     <div className='flex'>
//       <div className='w-64 bg-gray-800 text-white p-4'>
//         <h2 className='text-2xl font-bold mb-6'>Admin Dashboard</h2>
//         <ul>
//           <li className='mb-4'>
//             <Link to='/admin/restaurants' className='flex items-center'>
//               <FaStore className='mr-2' /> Restaurants
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/owners' className='flex items-center'>
//               <FaUserShield className='mr-2' /> Owners
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/customers' className='flex items-center'>
//               <FaUser className='mr-2' /> Customers
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/textmessages' className='flex items-center'>
//               <FaEnvelope className='mr-2' /> Text Messages
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/coupons' className='flex items-center'>
//               <FaTags className='mr-2' /> Coupons
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/coupontemplates' className='flex items-center'>
//               <FaClipboardList className='mr-2' /> Coupon Templates
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/deleted' className='flex items-center'>
//               <FaTrash className='mr-2' /> Deleted Items
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/memberships' className='flex items-center'>
//               <FaDollarSign className='mr-2' /> Memberships
//             </Link>
//           </li>
//           <li className='mb-4'>
//             <Link to='/admin/stats' className='flex items-center'>
//               <FaChartLine className='mr-2' /> Advanced Analytics
//             </Link>
//           </li>
//         </ul>
//       </div>

//       <div className='flex-1 p-8'>
//         <h1 className='text-3xl font-bold mb-8'>Admin Dashboard Overview</h1>
//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8'>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaStore className='mr-2' /> Total Restaurants
//             </h3>
//             <p className='text-3xl'>{dashboardData.totalRestaurants}</p>
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaUserShield className='mr-2' /> Total Owners
//             </h3>
//             <p className='text-3xl'>{dashboardData.totalOwners}</p>
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaUser className='mr-2' /> Total Customers
//             </h3>
//             <p className='text-3xl'>{dashboardData.totalCustomers}</p>
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaEnvelope className='mr-2' /> Total Text Messages Sent
//             </h3>
//             <p className='text-3xl'>{dashboardData.totalTextMessagesSent}</p>
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaTags className='mr-2' /> Total Coupons
//             </h3>
//             <p className='text-3xl'>{dashboardData.totalCoupons}</p>
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaClipboardList className='mr-2' /> Total Coupon Templates
//             </h3>
//             <p className='text-3xl'>{dashboardData.totalCouponTemplates}</p>
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4 flex items-center'>
//               <FaDollarSign className='mr-2' /> Total Revenue from Memberships
//             </h3>
//             <p className='text-3xl'>${dashboardData.totalRevenue}</p>
//           </div>
//         </div>

//         <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4'>
//               Restaurants by Membership
//             </h3>
//             <Pie data={pieData} />
//           </div>
//           <div className='bg-white p-6 rounded-lg shadow-md'>
//             <h3 className='text-xl font-bold mb-4'>Subscription Growth</h3>
//             <Line data={lineData} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
  FaStore,
  FaUserShield,
  FaUser,
  FaEnvelope,
  FaTags,
  FaTrash,
  FaClipboardList,
  FaQrcode,
} from 'react-icons/fa';
import { FaChartBar, FaChartPie, FaUsers } from 'react-icons/fa';

const AdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get('/api/admin/dashboard', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDashboardData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [token]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='flex'>
      <div className='w-64 bg-gray-800 text-white p-4'>
        <h2 className='text-2xl font-bold mb-6'>Admin Dashboard</h2>
        <ul>
          <li className='mb-4'>
            <Link to='/admin/restaurants' className='flex items-center'>
              <FaStore className='mr-2' /> Restaurants
            </Link>
          </li>
          <li className='mb-4'>
            <Link to='/admin/owners' className='flex items-center'>
              <FaUserShield className='mr-2' /> Owners
            </Link>
          </li>
          <li className='mb-4'>
            <Link to='/admin/customers' className='flex items-center'>
              <FaUser className='mr-2' /> Customers
            </Link>
          </li>
          <li className='mb-4'>
            <Link to='/admin/textmessages' className='flex items-center'>
              <FaEnvelope className='mr-2' /> Text Messages
            </Link>
          </li>
          <li className='mb-4'>
            <Link to='/admin/coupons' className='flex items-center'>
              <FaTags className='mr-2' /> Coupons
            </Link>
          </li>
          <li className='mb-4'>
            <Link to='/admin/coupontemplates' className='flex items-center'>
              <FaClipboardList className='mr-2' /> Coupon Templates
            </Link>
          </li>
          <li className='mb-4'>
            <Link to='/admin/deleted' className='flex items-center'>
              <FaTrash className='mr-2' /> Deleted Items
            </Link>
          </li>
        </ul>
      </div>

      <div className='flex-1 p-8'>
        <h1 className='text-3xl font-bold mb-6'>Admin Dashboard</h1>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
          <div className='bg-blue-500 p-6 rounded-lg shadow-lg text-white flex items-center'>
            <FaStore className='text-4xl mr-4' />
            <div>
              <h2 className='text-2xl font-bold'>
                {dashboardData.totalRestaurants}
              </h2>
              <p>Total Restaurants</p>
            </div>
          </div>
          <div className='bg-green-500 p-6 rounded-lg shadow-lg text-white flex items-center'>
            <FaUsers className='text-4xl mr-4' />
            <div>
              <h2 className='text-2xl font-bold'>{dashboardData.totalUsers}</h2>
              <p>Total Users</p>
            </div>
          </div>
          <div className='bg-yellow-500 p-6 rounded-lg shadow-lg text-white flex items-center'>
            <FaChartBar className='text-4xl mr-4' />
            <div>
              <h2 className='text-2xl font-bold'>
                {dashboardData.totalTextMessages}
              </h2>
              <p>Total Text Messages</p>
            </div>
          </div>
          <div className='bg-red-500 p-6 rounded-lg shadow-lg text-white flex items-center'>
            <FaChartPie className='text-4xl mr-4' />
            <div>
              <h2 className='text-2xl font-bold'>
                {dashboardData.totalCoupons}
              </h2>
              <p>Total Coupons</p>
            </div>
          </div>
        </div>
        <h2 className='text-3xl font-bold mb-8'>Admin Dashboard</h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h3 className='text-xl font-bold mb-4 flex items-center'>
              <FaStore className='mr-2' /> Total Restaurants
            </h3>
            <p className='text-3xl'>{dashboardData.totalRestaurants}</p>
          </div>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h3 className='text-xl font-bold mb-4 flex items-center'>
              <FaUserShield className='mr-2' /> Total Owners
            </h3>
            <p className='text-3xl'>{dashboardData.totalOwners}</p>
          </div>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h3 className='text-xl font-bold mb-4 flex items-center'>
              <FaUser className='mr-2' /> Total Customers
            </h3>
            <p className='text-3xl'>{dashboardData.totalCustomers}</p>
          </div>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h3 className='text-xl font-bold mb-4 flex items-center'>
              <FaEnvelope className='mr-2' /> Total Text Messages Sent
            </h3>
            <p className='text-3xl'>{dashboardData.totalTextMessagesSent}</p>
          </div>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h3 className='text-xl font-bold mb-4 flex items-center'>
              <FaTags className='mr-2' /> Total Coupons
            </h3>
            <p className='text-3xl'>{dashboardData.totalCoupons}</p>
          </div>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h3 className='text-xl font-bold mb-4 flex items-center'>
              <FaClipboardList className='mr-2' /> Total Coupon Templates
            </h3>
            <p className='text-3xl'>{dashboardData.totalCouponTemplates}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { FaChartBar, FaChartPie, FaUsers, FaStore } from 'react-icons/fa';
// import Chart from 'chart.js/auto';

// const AdminDashboard = () => {
//   const [stats, setStats] = useState({});
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchStats = async () => {
//       try {
//         const response = await axios.get('/api/admin/stats', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setStats(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching stats:', error);
//       }
//     };

//     fetchStats();
//   }, [token]);

//   useEffect(() => {
//     if (!loading) {
//       // Example chart setup
//       const ctx = document.getElementById('restaurantChart').getContext('2d');
//       new Chart(ctx, {
//         type: 'pie',
//         data: {
//           labels: ['Active Restaurants', 'Inactive Restaurants'],
//           datasets: [
//             {
//               data: [stats.activeRestaurants, stats.inactiveRestaurants],
//               backgroundColor: ['#4CAF50', '#F44336'],
//             },
//           ],
//         },
//         options: {
//           responsive: true,
//         },
//       });
//     }
//   }, [loading, stats]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//         <div className="bg-blue-500 p-6 rounded-lg shadow-lg text-white flex items-center">
//           <FaStore className="text-4xl mr-4" />
//           <div>
//             <h2 className="text-2xl font-bold">{stats.totalRestaurants}</h2>
//             <p>Total Restaurants</p>
//           </div>
//         </div>
//         <div className="bg-green-500 p-6 rounded-lg shadow-lg text-white flex items-center">
//           <FaUsers className="text-4xl mr-4" />
//           <div>
//             <h2 className="text-2xl font-bold">{stats.totalUsers}</h2>
//             <p>Total Users</p>
//           </div>
//         </div>
//         <div className="bg-yellow-500 p-6 rounded-lg shadow-lg text-white flex items-center">
//           <FaChartBar className="text-4xl mr-4" />
//           <div>
//             <h2 className="text-2xl font-bold">{stats.totalTextMessages}</h2>
//             <p>Total Text Messages</p>
//           </div>
//         </div>
//         <div className="bg-red-500 p-6 rounded-lg shadow-lg text-white flex items-center">
//           <FaChartPie className="text-4xl mr-4" />
//           <div>
//             <h2 className="text-2xl font-bold">{stats.totalCoupons}</h2>
//             <p>Total Coupons</p>
//           </div>
//         </div>
//       </div>
//       <div className="mt-8">
//         <canvas id="restaurantChart"></canvas>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   FaUsers,
//   FaEnvelope,
//   FaStore,
//   FaTags,
//   FaChartLine,
//   FaPlus,
// } from 'react-icons/fa';

// const AdminDashboard = () => {
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchStats = async () => {
//       try {
//         const response = await axios.get(`/api/admin/dashboard`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setStats(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching stats:', error);
//         setLoading(false);
//       }
//     };

//     fetchStats();
//   }, [token]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Admin Dashboard</h1>
//       <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8'>
//         <div className='bg-blue-500 p-6 rounded-lg shadow-lg text-white'>
//           <FaUsers className='text-3xl mb-4' />
//           <h2 className='text-xl font-bold'>Total Customers</h2>
//           <p className='text-3xl'>{stats.totalCustomers}</p>
//         </div>
//         <div className='bg-green-500 p-6 rounded-lg shadow-lg text-white'>
//           <FaStore className='text-3xl mb-4' />
//           <h2 className='text-xl font-bold'>Total Restaurants</h2>
//           <p className='text-3xl'>{stats.totalRestaurants}</p>
//         </div>
//         <div className='bg-purple-500 p-6 rounded-lg shadow-lg text-white'>
//           <FaEnvelope className='text-3xl mb-4' />
//           <h2 className='text-xl font-bold'>Total Text Messages Sent</h2>
//           <p className='text-3xl'>{stats.totalMessagesSent}</p>
//         </div>
//         <div className='bg-red-500 p-6 rounded-lg shadow-lg text-white'>
//           <FaTags className='text-3xl mb-4' />
//           <h2 className='text-xl font-bold'>Total Coupons</h2>
//           <p className='text-3xl'>{stats.totalCoupons}</p>
//         </div>
//       </div>
//       <div className='bg-gray-100 p-6 rounded-lg shadow-lg'>
//         <h2 className='text-2xl font-bold mb-4'>Recent Activity</h2>
//         <ul>
//           {stats?.recentActivity?.map((activity) => (
//             <li key={activity._id} className='mb-4'>
//               <p className='text-gray-700'>{activity.description}</p>
//               <p className='text-sm text-gray-500'>
//                 {new Date(activity.createdAt).toLocaleString()}
//               </p>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   FaUser,
//   FaEnvelope,
//   FaStore,
//   FaTag,
//   FaClipboardList,
// } from 'react-icons/fa';

// const AdminDashboard = () => {
//   const [restaurants, setRestaurants] = useState([]);
//   const [textMessages, setTextMessages] = useState([]);
//   const [subscribers, setSubscribers] = useState([]);
//   const [coupons, setCoupons] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [restaurantsRes, textMessagesRes, subscribersRes, couponsRes] =
//           await Promise.all([
//             axios.get('/api/admin/restaurants', {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//             axios.get('/api/admin/textmessages', {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//             axios.get('/api/admin/subscribers', {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//             axios.get('/api/admin/coupons', {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//           ]);

//         setRestaurants(restaurantsRes.data);
//         setTextMessages(textMessagesRes.data);
//         setSubscribers(subscribersRes.data);
//         setCoupons(couponsRes.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching admin data:', error);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [token]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h1 className='text-3xl font-bold mb-6'>Admin Dashboard</h1>

//       <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8'>
//         <div className='bg-blue-500 p-6 rounded-lg text-white shadow-md'>
//           <h2 className='text-2xl font-bold mb-4 flex items-center'>
//             <FaStore className='mr-3' /> Restaurants
//           </h2>
//           <p className='text-3xl font-semibold'>{restaurants.length}</p>
//         </div>

//         <div className='bg-green-500 p-6 rounded-lg text-white shadow-md'>
//           <h2 className='text-2xl font-bold mb-4 flex items-center'>
//             <FaEnvelope className='mr-3' /> Text Messages
//           </h2>
//           <p className='text-3xl font-semibold'>{textMessages.length}</p>
//         </div>

//         <div className='bg-yellow-500 p-6 rounded-lg text-white shadow-md'>
//           <h2 className='text-2xl font-bold mb-4 flex items-center'>
//             <FaUser className='mr-3' /> Subscribers
//           </h2>
//           <p className='text-3xl font-semibold'>{subscribers.length}</p>
//         </div>

//         <div className='bg-red-500 p-6 rounded-lg text-white shadow-md'>
//           <h2 className='text-2xl font-bold mb-4 flex items-center'>
//             <FaTag className='mr-3' /> Coupons
//           </h2>
//           <p className='text-3xl font-semibold'>{coupons.length}</p>
//         </div>
//       </div>

//       {/* Detailed Lists */}
//       <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6'>
//         <div>
//           <h2 className='text-xl font-bold mb-4'>Recent Restaurants</h2>
//           <ul>
//             {restaurants.slice(0, 5).map((restaurant) => (
//               <li
//                 key={restaurant._id}
//                 className='mb-2 p-4 bg-gray-100 rounded shadow-sm'
//               >
//                 {restaurant.name}
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div>
//           <h2 className='text-xl font-bold mb-4'>Recent Text Messages</h2>
//           <ul>
//             {textMessages.slice(0, 5).map((message) => (
//               <li
//                 key={message._id}
//                 className='mb-2 p-4 bg-gray-100 rounded shadow-sm'
//               >
//                 {message.content}
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div>
//           <h2 className='text-xl font-bold mb-4'>Recent Subscribers</h2>
//           <ul>
//             {subscribers.slice(0, 5).map((subscriber) => (
//               <li
//                 key={subscriber._id}
//                 className='mb-2 p-4 bg-gray-100 rounded shadow-sm'
//               >
//                 {subscriber.customer.phoneNumber}
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div>
//           <h2 className='text-xl font-bold mb-4'>Recent Coupons</h2>
//           <ul>
//             {coupons.slice(0, 5).map((coupon) => (
//               <li
//                 key={coupon._id}
//                 className='mb-2 p-4 bg-gray-100 rounded shadow-sm'
//               >
//                 {coupon.code} - {coupon.discount}%
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

// import React, { useEffect, useState } from 'react';
// import {
//   fetchDeletedEntities,
//   restoreEntity,
//   deleteEntity,
// } from '../../services/adminService';
// import { Link } from 'react-router-dom';

// function AdminDashboard() {
//   const [deletedEntities, setDeletedEntities] = useState({
//     restaurants: [],
//     customers: [],
//     coupons: [],
//     textMessages: [],
//   });

//   useEffect(() => {
//     const loadDeletedEntities = async () => {
//       const response = await fetchDeletedEntities();
//       setDeletedEntities(response.data);
//     };
//     loadDeletedEntities();
//   }, []);

//   const handleRestore = async (type, id) => {
//     await restoreEntity(type, id);
//     setDeletedEntities((prev) => ({
//       ...prev,
//       [type]: prev[type].filter((entity) => entity._id !== id),
//     }));
//   };

//   const handlePermanentDelete = async (type, id) => {
//     await deleteEntity(type, id);
//     setDeletedEntities((prev) => ({
//       ...prev,
//       [type]: prev[type].filter((entity) => entity._id !== id),
//     }));
//   };

//   return (
//     <div className='p-4'>
//       <nav className='admin-nav'>
//         <ul>
//           <li>
//             <Link to={`admin/deleted-entities`}>Deleted Entities</Link>
//           </li>
//           <li>
//             <Link to={`admin/coupon-management`}>Coupon Management</Link>
//           </li>
//           <li>
//             <Link to={`admin/create-owner`}>Create New Owner</Link>
//           </li>
//           <li>
//             <Link to={`admin/create-restaurant`}>Create New Restaurant</Link>
//           </li>
//           <li>
//             <Link to='/admin/restaurants'>Manage Restaurants</Link>
//           </li>
//           <li>
//             <Link to='/admin/owners'>Manage Owners</Link>
//           </li>
//           <li>
//             <Link to='/admin/coupons'>Manage Coupons</Link>
//           </li>
//           <li>
//             <Link to='/admin/customers'>Manage Customers</Link>
//           </li>
//           <li>
//             <Link to='/admin/deleted-items'>View Deleted Items</Link>
//           </li>
//         </ul>
//       </nav>
//       <h1 className='text-2xl font-bold mb-4'>Admin Dashboard</h1>
//       <div className='space-y-6'>
//         <DeletedEntitiesTable
//           title='Deleted Restaurants'
//           entities={deletedEntities.restaurants}
//           type='restaurant'
//           onRestore={handleRestore}
//           onDelete={handlePermanentDelete}
//         />
//         <DeletedEntitiesTable
//           title='Deleted Customers'
//           entities={deletedEntities.customers}
//           type='customer'
//           onRestore={handleRestore}
//           onDelete={handlePermanentDelete}
//         />
//         <DeletedEntitiesTable
//           title='Deleted Coupons'
//           entities={deletedEntities.coupons}
//           type='coupon'
//           onRestore={handleRestore}
//           onDelete={handlePermanentDelete}
//         />
//         <DeletedEntitiesTable
//           title='Deleted Text Messages'
//           entities={deletedEntities.textMessages}
//           type='textMessage'
//           onRestore={handleRestore}
//           onDelete={handlePermanentDelete}
//         />
//       </div>
//     </div>
//   );
// }

// function DeletedEntitiesTable({ title, entities, type, onRestore, onDelete }) {
//   return (
//     <div>
//       <h2 className='text-xl font-semibold mb-2'>{title}</h2>
//       <table className='w-full border'>
//         <thead>
//           <tr>
//             <th className='border p-2'>ID</th>
//             <th className='border p-2'>Details</th>
//             <th className='border p-2'>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {entities.map((entity) => (
//             <tr key={entity._id}>
//               <td className='border p-2'>{entity._id}</td>
//               <td className='border p-2'>
//                 {/* Customize this based on the entity type */}
//                 {type === 'restaurant' && entity.name}
//                 {type === 'customer' && entity.phoneNumber}
//                 {type === 'coupon' && entity.description}
//                 {type === 'textMessage' && entity.content}
//               </td>
//               <td className='border p-2 space-x-2'>
//                 <button
//                   onClick={() => onRestore(type, entity._id)}
//                   className='bg-blue-500 text-white px-2 py-1 rounded'
//                 >
//                   Restore
//                 </button>
//                 <button
//                   onClick={() => onDelete(type, entity._id)}
//                   className='bg-red-500 text-white px-2 py-1 rounded'
//                 >
//                   Delete Permanently
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default AdminDashboard;
